import { Png, Svg } from "../../assets";

export const socialNames: Record<SocialNetworksId, string> = {
  FB: "Facebook",
  IG: "Instagram",
  LI: "LinkedIn",
  TW: "X",
  TT: "TikTok",
  IG_STORY: "Instagram",
  SC: "SocialCoach",
  GL: "Google",
  ZL: "Zillow",
  BE: "Birdeye",
  IF: "Internal",
  EX: "Experience",
};

export const socialNetworkNames: Record<SocialNetworksId, string> = {
  FB: "Facebook",
  IG: "Instagram",
  LI: "LinkedIn",
  TW: "X",
  TT: "TikTok",
  IG_STORY: "Instagram Story",
  SC: "SocialCoach",
  GL: "Google",
  ZL: "Zillow",
  BE: "Birdeye",
  IF: "Internal",
  EX: "Experience",
};

export const socialNetworkConnectionNames: Record<SocialNetworksId, string> = {
  FB: "Page",
  IG: "Account",
  LI: "Account",
  TW: "Account",
  TT: "Account",
  IG_STORY: "Account",
  SC: "Account",
  ZL: "Listing",
  GL: "Listing",
  BE: "Listing",
  IF: "Listing",
  EX: "Listing",
};

export const socialIcons: Record<SocialNetworksId, string> = {
  FB: Png.FB,
  TW: Png.TW,
  LI: Png.LI,
  IG: Png.IG,
  TT: Png.TT,
  IG_STORY: Png.IG_STORY,
  SC: Png.LogoCircleDark,
  GL: Png.GL,
  ZL: Png.ZL,
  BE: Png.BE,
  EX: Png.Experience,
  IF: Png.InternalFeedback,
};

export const socialSVGs: Record<SocialNetworksId, string> = {
  FB: Svg.FacebookSVG,
  TW: Svg.TwitterSVG,
  LI: Svg.LinkedInSVG,
  IG: Svg.InstagramSVG,
  TT: Svg.TiktokSVG,
  IG_STORY: Png.IG_STORY,
  SC: Png.LogoCircleDark,
  GL: Svg.GoogleColorSVG,
  ZL: Svg.ZillowSVG,
  BE: Png.BE,
  EX: Svg.ExperienceSVG,
  IF: Svg.InternalFeedback,
};

export const socialNamesKeys: { [key: string]: string } = {
  _FB: "facebook",
  _IG: "instagram",
  _LI: "linkedIn",
  _TW: "twitter",
  _TT: "tiktok",
  _SC: "socialCoach",
  _GL: "google",
  _ZL: "zillow",
  _BE: "birdeye",
  _EX: "experience",
  _IF: "internal",
};

export type SocialNetworksId = "IG" | "FB" | "TW" | "LI" | "TT" | "IG_STORY" | "SC" | "GL" | "ZL" | "BE" | "IF" | "EX";
export type SocialNetworksName =
  | "facebook"
  | "twitter"
  | "linkedIn"
  | "instagram"
  | "tiktok"
  | "socialCoach"
  | "google"
  | "zillow"
  | "birdeye"
  | "experience"
  | "internal";

export const TEXT_ONLY_SOCIAL_NETWORKS: SocialNetworksId[] = ["FB", "TW", "LI"];
export const CAPTION_EDITING_SOCIAL_NETWORKS: SocialNetworksId[] = ["FB", "LI"];
export interface SocialNetworkMetadata {
  key: string;
  name: string;
  icon: string;
  forPosting?: boolean;
}
export const SOCIAL_NETWORK_METADATA: Record<SocialNetworksId, SocialNetworkMetadata> = {
  IG: {
    key: "instagram",
    name: socialNetworkNames["IG"],
    icon: socialIcons["IG"],
    forPosting: true,
  },
  FB: {
    key: "facebook",
    name: socialNetworkNames["FB"],
    icon: socialIcons["FB"],
    forPosting: true,
  },
  TW: {
    key: "x",
    name: socialNetworkNames["TW"],
    icon: socialIcons["TW"],
    forPosting: true,
  },
  LI: {
    key: "linkedIn",
    name: socialNetworkNames["LI"],
    icon: socialIcons["LI"],
    forPosting: true,
  },
  TT: {
    key: "tikTok",
    name: socialNetworkNames["TT"],
    icon: socialIcons["TT"],
    forPosting: true,
  },
  IG_STORY: {
    key: "instagramStory",
    name: socialNetworkNames["IG_STORY"],
    icon: socialIcons["IG_STORY"],
    forPosting: true,
  },
  SC: {
    key: "socialCoach",
    name: socialNetworkNames["SC"],
    icon: socialIcons["SC"],
    forPosting: false,
  },
  GL: {
    key: "google",
    name: socialNetworkNames["GL"],
    icon: socialIcons["GL"],
    forPosting: false,
  },
  ZL: {
    key: "zillow",
    name: socialNetworkNames["ZL"],
    icon: socialIcons["ZL"],
    forPosting: false,
  },
  BE: {
    key: "birdeye",
    name: socialNetworkNames["BE"],
    icon: socialIcons["BE"],
    forPosting: false,
  },
  IF: {
    key: "internal",
    name: "Internal",
    icon: socialIcons["IF"],
    forPosting: false,
  },
  EX: {
    key: "experience",
    name: "Experience",
    icon: socialIcons["EX"],
    forPosting: false,
  },
};
export interface SocialNetworkPreLoaded {
  socialNetworkId: SocialNetworksId;
  externalLink?: string;
  status?: string;
}
